import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyPeople } from '@/features/participant-portal/my-people'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-people/',
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: MyPeople,
})
